'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslation, Locale } from '@/context/I18nContext';
import { ModeConfig } from './types';
import { trackEvent } from '@/lib/umami';
interface LanguageSwitcherProps {
  design?: ModeConfig['design'];
  isDark?: boolean;
}
export default function LanguageSwitcher(t0) {
  const $ = _c(13);
  const {
    design,
    isDark
  } = t0;
  const {
    locale,
    setLocale
  } = useTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      code: "en",
      label: "English",
      flag: "\uD83C\uDDEC\uD83C\uDDE7"
    }, {
      code: "tr",
      label: "T\xFCrk\xE7e",
      flag: "\uD83C\uDDF9\uD83C\uDDF7"
    }, {
      code: "de",
      label: "Deutsch",
      flag: "\uD83C\uDDE9\uD83C\uDDEA"
    }];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const languages = t1;
  let t2;
  if ($[1] !== design || $[2] !== isDark) {
    t2 = () => {
      if (!design) {
        return "w-full px-3 py-2 rounded-lg bg-white/10 border border-white/20 text-sm";
      }
      const base = `w-full px-3 py-2 ${design.borderRadius} text-sm font-medium border ${design.border}`;
      if (isDark) {
        return `${base} ${design.cardBg} ${design.textPrimary} border-white/10`;
      }
      return `${base} ${design.cardBg} ${design.textPrimary}`;
    };
    $[1] = design;
    $[2] = isDark;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getSelectStyles = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="sr-only">Change language</span>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = getSelectStyles();
  let t5;
  if ($[5] !== locale || $[6] !== setLocale) {
    t5 = e => {
      const next = e.target.value as Locale;
      if (next !== locale) {
        trackEvent("lang_change", {
          from: locale,
          to: next
        });
        setLocale(next);
      }
    };
    $[5] = locale;
    $[6] = setLocale;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = languages.map(_temp);
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== locale || $[10] !== t4 || $[11] !== t5) {
    t7 = <label className="block w-full">{t3}<select className={t4} value={locale} onChange={t5}>{t6}</select></label>;
    $[9] = locale;
    $[10] = t4;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}
function _temp(lang) {
  return <option key={lang.code} value={lang.code}>{`${lang.flag} ${lang.label}`}</option>;
}